'use client';

import { API_ASSET_ROUTE } from '@/config/constants';
import {
    TypeButtonWithoutUnresolvableLinksResponse,
    TypeMegaMenuComponentWithoutUnresolvableLinksResponse,
} from '@/features/contentful/_generated';
import { getLocalizedLink } from '@/utils/getLocalizedLink';
import { handleLinkClick } from '@/utils/handleLinkClick';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import Link from 'next/link';

const FooterLink = ({
    buttonData,
    lang,
}: {
    buttonData: TypeButtonWithoutUnresolvableLinksResponse;
    lang: string;
}) => {
    const inspectorProps = useContentfulInspectorMode({ entryId: buttonData.sys.id });

    return (
        <li>
            <Link
                href={
                    buttonData?.fields?.asset
                        ? `${API_ASSET_ROUTE}${buttonData?.fields?.asset?.fields?.file?.fileName}`
                        : getLocalizedLink(buttonData?.fields?.link, lang)
                }
                onClick={(e: React.MouseEvent<HTMLAnchorElement>) =>
                    handleLinkClick(e, buttonData?.fields?.asset?.fields?.file?.url)
                }
                target={buttonData?.fields?.target}
                {...inspectorProps({
                    fieldId: 'title',
                })}
                rel="nofollow"
            >
                {buttonData?.fields?.title}
            </Link>
        </li>
    );
};

const FooterLinks = ({
    lang = 'en',
    footerColumns,
}: {
    lang: string;
    footerColumns?: TypeMegaMenuComponentWithoutUnresolvableLinksResponse['fields']['columns'];
}) => {
    const GTMFooterLinkHandler = (e: React.MouseEvent<HTMLUListElement>) => {
        const target = e.target as HTMLElement;
        const isLink = target.closest('a');
        if (isLink) {
            window.dataLayer && window.dataLayer.push({ event: 'footer_link_click' });
        }
    };

    return (
        <div className="footerLinks">
            <ul onClick={GTMFooterLinkHandler}>
                {footerColumns?.map((column) => {
                    const buttonData = column as TypeButtonWithoutUnresolvableLinksResponse;

                    return (
                        <FooterLink key={buttonData?.sys?.id} buttonData={buttonData} lang={lang} />
                    );
                })}
            </ul>
        </div>
    );
};

export default FooterLinks;
